// app/javascript/controllers/swal_confirm_controller.js
import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
    static values = {
        message: String,
        text: { type: String, default: "This cannot be undone." },
        confirmButton: { type: String, default: "Yes, delete it!" },
        cancelButton:  { type: String, default: "Cancel" }
    }

    confirm = (event) => {
        event.preventDefault()

        const href   = this.element.getAttribute("href")
        const method = (this.element.dataset.turboMethod || "get").toLowerCase()

        Swal.fire({
            title: this.messageValue || "Are you sure?",
            text: this.textValue,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: this.confirmButtonValue,
            cancelButtonText: this.cancelButtonValue,
            reverseButtons: true,
            customClass: {
                popup: "swal2-ea-popup",
                title: "swal2-ea-title",
                confirmButton: "swal2-ea-confirm",
                cancelButton: "swal2-ea-cancel"
            },
            buttonsStyling: false
        }).then((result) => {
            if (!result.isConfirmed) return

            if (method === "delete" || method === "post" || method === "patch" || method === "put") {
                // Build a Turbo-enabled form and requestSubmit() so Turbo
                // sets the proper Accept header and processes turbo_stream.
                const form = document.createElement("form")
                form.action = href
                form.method = "post"
                form.dataset.turbo = "true"     // <<< important

                const turboFrame = this.element.dataset.turboFrame
                if (turboFrame) form.dataset.turboFrame = turboFrame

                // method override
                if (method !== "post") {
                    const m = document.createElement("input")
                    m.type = "hidden"
                    m.name = "_method"
                    m.value = method
                    form.appendChild(m)
                }

                // CSRF
                const token = document.querySelector("meta[name=csrf-token]")?.content
                if (token) {
                    const csrf = document.createElement("input")
                    csrf.type = "hidden"
                    csrf.name = "authenticity_token"
                    csrf.value = token
                    form.appendChild(csrf)
                }

                document.body.appendChild(form)
                form.requestSubmit()            // <<< use requestSubmit (Turbo fetch)
            } else {
                Turbo.visit(href, { action: "replace" })
            }
        })
    }

    connect()   { this.element.addEventListener("click", this.confirm) }
    disconnect(){ this.element.removeEventListener("click", this.confirm) }
}
